module.exports = __webpack_public_path__ + "static/services-head-1-207742e62131a1f69f4b84945a8fa41f.png";